import {InjectionToken, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";
import {MaterialModule} from "../../material-module";
import {loaderStyle} from "./file-loader";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule.forChild(),
  ],
  entryComponents: [],
  exports: []
})
export class ChartBlocksModule {
  constructor() {
    loaderStyle();
  }
  public static forRoot(config = {}): ModuleWithProviders {
    return {
      ngModule: ChartBlocksModule,
      providers: [
        {provide: 'inject-config', useValue: config},
      ],
    };
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/chartBlocks/chartBlocks.module.ts